(function (root, factory) {
  if (root && root.KolayOtoCartMontajCities) {
    if (typeof module === 'object' && module.exports) {
      module.exports = root.KolayOtoCartMontajCities;
    }
    return;
  }

  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.KolayOtoCartMontajCities = api;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MOBILE_SERVICE_HANDLE = 'mobil-montaj-hizmeti';
  var CSV_CACHE_VERSION = '2026-08-23-mobile-service-cities';
  var CSV_CACHE_PREFIX = 'kolayoto:montaj-csv:' + CSV_CACHE_VERSION + ':';
  var CSV_CACHE_MAX_AGE = 7 * 24 * 60 * 60 * 1000;
  var CSV_SOURCE_PAGE_URL = '/pages/montaj-noktalari';
  var CSV_SOURCE_ATTRIBUTE = 'data-mobile-montaj-csv-url';
  var cityOrder = [
    'Ankara',
    'Antalya',
    'Aydın',
    'Balıkesir',
    'Diyarbakır',
    'Edirne',
    'İstanbul',
    'İzmir',
    'Kocaeli',
    'Konya',
    'Mersin',
    'Uşak',
    'Yozgat'
  ];
  var fallbackCities = cityOrder.filter(function (city) {
    return city !== 'Balıkesir';
  });
  var csvRequests = {};
  var csvSourceRequest = null;

  function getFallbackCities() {
    return fallbackCities.slice();
  }

  function getCsvUrlFromMarkup(markup) {
    var match = String(markup || '').match(/data-mobile-montaj-csv-url=(['"])(.*?)\1/i);
    if (!match) return '';

    return match[2]
      .replace(/&amp;/g, '&')
      .replace(/&quot;/g, '"')
      .replace(/&#39;|&#x27;/g, "'")
      .trim();
  }

  function getCsvUrlFromCurrentPage() {
    if (typeof document === 'undefined') return '';

    var source = document.querySelector('[' + CSV_SOURCE_ATTRIBUTE + ']');
    return source ? String(source.getAttribute(CSV_SOURCE_ATTRIBUTE) || '').trim() : '';
  }

  function resolveMobileServiceCsvUrl(configuredUrl) {
    var url = String(configuredUrl || '').trim();
    if (url) return Promise.resolve(url);

    url = getCsvUrlFromCurrentPage();
    if (url) return Promise.resolve(url);

    if (!csvSourceRequest) {
      csvSourceRequest = fetch(CSV_SOURCE_PAGE_URL, { cache: 'no-cache' })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(response.status + ' ' + response.statusText);
          }

          return response.text();
        })
        .then(getCsvUrlFromMarkup)
        .catch(function () {
          csvSourceRequest = null;
          return '';
        });
    }

    return csvSourceRequest;
  }

  function parseCSV(csv) {
    var rows = [];
    var row = [];
    var value = '';
    var inQuotes = false;
    var source = String(csv || '').replace(/^\uFEFF/, '');

    for (var index = 0; index < source.length; index += 1) {
      var character = source[index];
      var nextCharacter = source[index + 1];

      if (character === '"' && inQuotes && nextCharacter === '"') {
        value += '"';
        index += 1;
      } else if (character === '"') {
        inQuotes = !inQuotes;
      } else if (character === ',' && !inQuotes) {
        row.push(value.trim());
        value = '';
      } else if ((character === '\n' || character === '\r') && !inQuotes) {
        if (character === '\r' && nextCharacter === '\n') {
          index += 1;
        }

        row.push(value.trim());
        value = '';

        if (row.some(function (cell) { return cell !== ''; })) {
          rows.push(row);
        }

        row = [];
      } else {
        value += character;
      }
    }

    row.push(value.trim());
    if (row.some(function (cell) { return cell !== ''; })) {
      rows.push(row);
    }

    return rows;
  }

  function normalizeHeader(value) {
    return String(value || '').trim().toLocaleLowerCase('tr-TR');
  }

  function sortCities(cities) {
    var preferredIndexes = {};
    cityOrder.forEach(function (city, index) {
      preferredIndexes[city.toLocaleLowerCase('tr-TR')] = index;
    });

    return cities.slice().sort(function (firstCity, secondCity) {
      var firstIndex = preferredIndexes[firstCity.toLocaleLowerCase('tr-TR')];
      var secondIndex = preferredIndexes[secondCity.toLocaleLowerCase('tr-TR')];
      var firstIsPreferred = typeof firstIndex === 'number';
      var secondIsPreferred = typeof secondIndex === 'number';

      if (firstIsPreferred && secondIsPreferred) {
        return firstIndex - secondIndex;
      }

      if (firstIsPreferred) return -1;
      if (secondIsPreferred) return 1;

      return firstCity.localeCompare(secondCity, 'tr');
    });
  }

  function getMobileServiceCities(csv, mobileServiceHandle) {
    var rows = parseCSV(csv);
    var headers = rows.shift() || [];
    var provinceIndex = headers.map(normalizeHeader).indexOf('province');
    var productsIndex = headers.map(normalizeHeader).indexOf('products');
    var serviceHandle = String(mobileServiceHandle || MOBILE_SERVICE_HANDLE).toLocaleLowerCase('tr-TR');
    var cities = {};

    if (provinceIndex === -1 || productsIndex === -1) {
      return [];
    }

    rows.forEach(function (columns) {
      var province = String(columns[provinceIndex] || '').trim().normalize('NFC');
      var products = String(columns[productsIndex] || '')
        .split(',')
        .map(function (handle) {
          return handle.trim().replace(/^"|"$/g, '').toLocaleLowerCase('tr-TR');
        });

      if (province && products.indexOf(serviceHandle) !== -1) {
        cities[province.toLocaleLowerCase('tr-TR')] = province;
      }
    });

    return sortCities(Object.keys(cities).map(function (key) { return cities[key]; }));
  }

  function getCachedCSV(url) {
    try {
      var cachedValue = window.localStorage.getItem(CSV_CACHE_PREFIX + url);
      if (!cachedValue) return null;

      var cached = JSON.parse(cachedValue);
      if (!cached.cachedAt || Date.now() - cached.cachedAt > CSV_CACHE_MAX_AGE) {
        window.localStorage.removeItem(CSV_CACHE_PREFIX + url);
        return null;
      }

      return typeof cached.value === 'string' ? cached.value : null;
    } catch (error) {
      return null;
    }
  }

  function setCachedCSV(url, csv) {
    try {
      window.localStorage.setItem(CSV_CACHE_PREFIX + url, JSON.stringify({
        cachedAt: Date.now(),
        value: csv
      }));
    } catch (error) {
      // Cache kullanılamasa da ağ isteğiyle devam edilir.
    }
  }

  function fetchCSV(url) {
    var cachedCSV = getCachedCSV(url);
    if (cachedCSV !== null) {
      return Promise.resolve(cachedCSV);
    }

    if (!csvRequests[url]) {
      csvRequests[url] = fetch(url, { cache: 'no-cache' })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(response.status + ' ' + response.statusText);
          }

          return response.text();
        })
        .then(function (csv) {
          setCachedCSV(url, csv);
          return csv;
        })
        .catch(function (error) {
          delete csvRequests[url];
          throw error;
        });
    }

    return csvRequests[url];
  }

  function loadMobileServiceCities(primaryUrl, fallbackUrl) {
    return resolveMobileServiceCsvUrl(primaryUrl || fallbackUrl).then(function (resolvedUrl) {
      if (!resolvedUrl) return '';

      return fetchCSV(primaryUrl || resolvedUrl).catch(function () {
        if (fallbackUrl && fallbackUrl !== primaryUrl) {
          return fetchCSV(fallbackUrl).catch(function () {
            return '';
          });
        }

        return '';
      });
    }).then(function (csv) {
      var cities = getMobileServiceCities(csv);
      return cities.length ? cities : getFallbackCities();
    });
  }

  function buildMobileMontajUrl(baseUrl, city) {
    var url = new URL(baseUrl || '/pages/montaj-noktalari?service=mobile&return_to=cart', 'https://kolayoto.local');
    url.searchParams.set('province', city);
    return url.pathname + url.search + url.hash;
  }

  function setStatus(option, message, isError) {
    var status = option.querySelector('[data-cart-mobile-city-status]');
    if (!status) return;

    status.textContent = message;
    status.hidden = !message;
    status.classList.toggle('is-error', Boolean(isError));
  }

  function renderCities(option, cities) {
    var list = option.querySelector('[data-cart-mobile-city-list]');
    var count = option.querySelector('[data-cart-mobile-city-count]');
    var card = option.closest('[data-cart-montaj-card]');
    var baseUrl = card ? card.getAttribute('data-mobile-montaj-page-url') : '';

    if (count) {
      count.textContent = cities.length + ' ilde hizmet';
    }

    if (!list) return;
    list.innerHTML = '';

    cities.forEach(function (city) {
      var link = document.createElement('a');
      link.className = option.classList.contains('minicart-montaj-mobile-option')
        ? 'minicart-montaj-mobile-city-chip'
        : 'cart-montaj-mobile-city-chip';
      link.href = buildMobileMontajUrl(baseUrl, city);
      link.textContent = city;
      list.appendChild(link);
    });

    setStatus(
      option,
      cities.length ? '' : 'Şu an mobil montaj hizmeti sunulan il bulunamadı.',
      !cities.length
    );
  }

  function loadOptionCities(option) {
    if (option._cityPromise) {
      return option._cityPromise;
    }

    var card = option.closest('[data-cart-montaj-card]');
    var primaryUrl = card ? card.getAttribute('data-mobile-montaj-csv-url') : '';
    var fallbackUrl = card ? card.getAttribute('data-mobile-montaj-fallback-url') : '';

    option._cityPromise = loadMobileServiceCities(primaryUrl, fallbackUrl)
      .then(function (cities) {
        renderCities(option, cities);
        return cities;
      })
      .catch(function (error) {
        option._cityPromise = null;
        setStatus(option, 'İller yüklenemedi. Lütfen tekrar deneyin.', true);
        throw error;
      });

    return option._cityPromise;
  }

  function bindOption(option) {
    if (option.dataset.cartMobileCitiesBound === 'true') {
      return;
    }

    var toggle = option.querySelector('[data-cart-mobile-montaj-toggle]');
    var panel = option.querySelector('[data-cart-mobile-cities]');
    if (!toggle || !panel) return;

    option.dataset.cartMobileCitiesBound = 'true';
    loadOptionCities(option).catch(function (error) {
      console.error('Mobil montaj illeri yüklenemedi:', error);
    });

    toggle.addEventListener('click', function () {
      var isExpanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(isExpanded));
      panel.hidden = !isExpanded;

      if (isExpanded) {
        loadOptionCities(option).catch(function (error) {
          console.error('Mobil montaj illeri yüklenemedi:', error);
        });
      }
    });
  }

  function init(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var options = Array.prototype.slice.call(scope.querySelectorAll('[data-cart-mobile-montaj-option]'));

    if (scope.matches && scope.matches('[data-cart-mobile-montaj-option]')) {
      options.unshift(scope);
    }

    options.forEach(bindOption);
  }

  function observeOptions() {
    if (typeof MutationObserver === 'undefined' || !document.body || document.body.dataset.cartMobileCitiesObserved === 'true') {
      return;
    }

    document.body.dataset.cartMobileCitiesObserved = 'true';

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node && node.nodeType === 1) {
            init(node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
        observeOptions();
      }, { once: true });
    } else {
      init(document);
      observeOptions();
    }
  }

  return {
    parseCSV: parseCSV,
    sortCities: sortCities,
    getMobileServiceCities: getMobileServiceCities,
    getFallbackCities: getFallbackCities,
    getCsvUrlFromMarkup: getCsvUrlFromMarkup,
    resolveMobileServiceCsvUrl: resolveMobileServiceCsvUrl,
    loadMobileServiceCities: loadMobileServiceCities,
    buildMobileMontajUrl: buildMobileMontajUrl,
    init: init
  };
});
